/**
 * @desc 查看环保监控曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorCurveRequest,
): Promise<defs.StandardReturn<defs.EPMonitorCurveResponse>> {
  return defHttp.post({
    url: '/wap/ProductionRealTime/getEPMonitorCurve',
    data,
  });
}

export function mock(
  data: defs.EPMonitorCurveRequest,
): Promise<defs.StandardReturn<defs.EPMonitorCurveResponse>> {
  return defHttp.post({
    url: '/mock/wap/ProductionRealTime/getEPMonitorCurve',
    data,
  });
}
